/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import './silo-crop-level.scss';

/* eslint-disable import/no-unresolved, import/default */

import siloCropLevelTemplate from './silo-crop-level.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('agrolog.client.siloCropLevel', [])
    .directive('agSiloCropLevel', SiloCropLevel)
    .name;

/*@ngInject*/
function SiloCropLevel() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            ctx: '='
        },
        controller: SiloCropLevelController,
        controllerAs: 'vm',
        templateUrl: siloCropLevelTemplate
    };
}

/* eslint-disable angular/angularelement */

/*@ngInject*/
function SiloCropLevelController($scope, $rootScope, $log, $element, $translate, $filter, $compile, toast, types, agTypes, agUtils, siloService, userService, attributeService, agDeviceService) {

    let vm = this;

    vm.cropLevelLoading = true;
    vm.loading = false;

    vm.showData = userService.getAuthority() === 'TENANT_ADMIN' || userService.getAuthority() === 'CUSTOMER_USER';
    vm.siloId = null;
    vm.silo = null;
    vm.levelIndicator = null;
    vm.siloData = null;
    vm.telemetryType = agTypes.telemetry.type.temperature;
    vm.allowEditSettings = true;
    vm.isDevice = true;
    
    vm.cropVolumePercentageDataKey = {
        color: agTypes.colors.maxColor,
        decimals: 1,
        units: "%"
    };

    vm.cropVolumePercentageSettings = {
        showValue: true,
        gaugeType: "donut",
        showUnitTitle: true,
        unitTitle: $translate.instant('ag.silo.crop-filled'),
        valueFont: {
            color: "#27ae60"
        }
    };

    var user = userService.getCurrentUser();

    if (user.authority === 'CUSTOMER_USER') {
        var userAdditionalInfo = userService.getCurrentUserDetails().additionalInfo;
        if (userAdditionalInfo.readOnly) {
            vm.allowEditSettings = false;
        }
    }

    vm.cropLevelLegendConfig = {
        displayMaxThreshold: true,
        displayMinThreshold: false
    };
    vm.cropLevelSubscriptionOptions = {
        callbacks: {
            onDataUpdated: onDataUpdated,
            onDataUpdateError: onDataUpdateError,
            dataLoading: (subscription) => {
                vm.cropLevelLoading = subscription.loadingData;
            }
        },
        useDashboardTimewindow: false
    };

    vm.levelIndicatorSubscription = null

    vm.displayValueTooltip = displayValueTooltip;
    vm.forceMeasurement = forceMeasurement;
    vm.getStatusColor = getStatusColor;
    vm.tempColor = tempColor;

    $scope.$watch('vm.ctx', () => {
        if (vm.ctx && vm.showData) {
            vm.ctx.widgetActions = [];
            vm.ctx.hideTitlePanel = false;

            vm.silo = null;
            vm.levelIndicator = null;
            if (vm.ctx.stateController) {
                vm.siloId = vm.ctx.stateController.getStateParams().entityId;
            }
            loadSilo();
            $scope.$watch(() => {
                    return vm.ctx.stateController.getStateParams().entityId;
                },
                (newSiloId, prevSiloId) => {
                    if (newSiloId && !angular.equals(newSiloId, prevSiloId)) {
                        vm.siloId = newSiloId;
                        vm.hideCropLevel = false;
                        loadSilo();
                    }
                }
            );
        }
    });

    /*
    $scope.$watch('vm.levelIndicator', () => {
        if (vm.levelIndicator) {
            vm.cropLevelLoading = true;
            var cropLevelSubscriptionsInfo = [{
                type: types.datasourceType.entity,
                entityType: types.entityType.device,
                entityId: vm.levelIndicator.id.id,
                entityName: vm.levelIndicator.name,
                timeseries: [],
                attributes: []
            }];

            var minLevelKey = { name: "min-crop-level", label: "Min Level" };
            var avgLevelKey = { name: "avg-crop-level", label: "Avg Level" };
            var maxLevelKey = { name: "max-crop-level", label: "Max Level" };
            
            var cropLevel1 = {name: 'crop-level-1', label: 'Crop Level 1'};
            
            if (vm.levelIndicator.mode !== 'auto') {
                cropLevelSubscriptionsInfo[0].timeseries.push(
                    cropLevel1
                 )
            } else {
                cropLevelSubscriptionsInfo[0].timeseries.push(
                    minLevelKey, avgLevelKey, maxLevelKey
                 )
            }
            vm.cropLevelFlotSubscriptionsInfo = angular.copy(cropLevelSubscriptionsInfo);

            vm.measurePoints = angular.fromJson(vm.levelIndicator.measurePoints);
            if (vm.measurePoints && vm.measurePoints.length) {
                for (let i = 0; i < vm.measurePoints.length; i++) {
                    var timeseriesKey = {
                        name: agTypes.telemetry.levelIndicator.cropLevelPrefix + vm.measurePoints[i].id,
                        label: $translate.instant('ag.silo.crop-level') + ' ' + vm.measurePoints[i].id,
                        color: "#8d6e63"
                    };
                    cropLevelSubscriptionsInfo[0].timeseries.push(timeseriesKey);
                }
            }

            

            // For single level case
            var angleDirectionOldKey = {
                name: "angle-direction-1",
                label: "Angle direction 1"
            };
            var statusKey = {
                name: agTypes.attributes.levelIndicatorClient.status,
                label: "Status"
            };
            var angleDirectionKey = { name: "angle-direction", label: "Angle direction" };
            var weightKey = { name: "crop-weight", label: "Crop Weight" };
            var volumeKey = { name: "crop-volume", label: "Crop Volume" };
            var maxSilovolumeKey = { name: "silo-volume", label: "Silo Volume" };
            
            var algorithmKey = { name: "algorithm", label: "Algorithm" };
            var modeKey = { name: 'mode', label: 'Mode'}
            var deviceTypeKey = { name: 'deviceType', label: 'Device Type'}
            
            cropLevelSubscriptionsInfo[0].timeseries.push(angleDirectionOldKey);
            cropLevelSubscriptionsInfo[0].attributes.push(statusKey, algorithmKey, modeKey, deviceTypeKey);
            cropLevelSubscriptionsInfo[0].timeseries.push(
                angleDirectionKey, weightKey, volumeKey, maxSilovolumeKey
            )

            vm.cropLevelSubscriptionOptions.timeWindowConfig = angular.copy(vm.ctx.dashboardTimewindow);
            vm.cropLevelSubscriptionOptions.timeWindowConfig.aggregation.type = types.aggregation.none.value;
            vm.cropLevelSubscriptionOptions.timeWindowConfig.aggregation.limit = 1;
            vm.ctx.subscriptionApi.createSubscriptionFromInfo(
                types.widgetType.timeseries.value, cropLevelSubscriptionsInfo, vm.cropLevelSubscriptionOptions, false, true).then(
                (subscription) => {
                    vm.subscription = subscription;
                }
            );
        }
    });*/

    $scope.$watch(() => {
        return vm.silo ? (vm.silo.label || vm.silo.name) : null;
    }, (title) => {
        if (vm.showData && vm.ctx && title) {
            vm.ctx.widgetTitle = $translate.instant('ag.silo.silo-crop-level') + ': ' + title;
        }
    });

    $scope.$on('dashboardTimewindowChanged', (event, newDashboardTimewindow) => {
        if (vm.subscription) {
            var newTimewindowConfig = angular.copy(newDashboardTimewindow);
            newTimewindowConfig.aggregation.type = types.aggregation.none.value;
            newTimewindowConfig.aggregation.limit = 1;
            vm.subscription.timeWindowConfig = newTimewindowConfig;
        }
    });

    $scope.$on('$destroy', () => {
        reset();
    });

    agUtils.getCropNames().then(
        (response) => {
            vm.cropNames = [];
            var cropNames = response.jsonValue;
            for (var property in cropNames) {
                var cropNameObj = {};
                cropNameObj.nameId = property;
                cropNameObj.value = cropNames[property];
                vm.cropNames.push(cropNameObj);
            }
        }
    );

    agUtils.getCropValues().then(
        (response) => {
            vm.cropValues = response.jsonValue;
        }
    );

    function reset() {
        if (vm.subscription) {
            vm.ctx.subscriptionApi.removeSubscription(vm.subscription.id);
        }
        if (vm.levelIndicatorSubscription) {
            vm.ctx.subscriptionApi.removeSubscription(vm.levelIndicatorSubscription.id)
        }
        vm.levelIndicatorDevices = []
        vm.levelIndicator = null
        vm.cropLevelFlotSubscriptionsInfo = null;
        vm.cropLevel = null;
        vm.cropLevelTs = "";
        vm.cropLevelLabel = "";
        vm.statusId = 0;
        vm.statusMessage = "ag.silo.status-unknown";
        vm.cropWeight = null;
        vm.cropVolumePercentage = null;
    }

    vm.maxSiloWeight = undefined;
    function onDataUpdated(subscription, apply) {
        var data = subscription.data;
        let attributes = {}
        for (var item of data) {
            let key = item.dataKey.name
            let lastValue = item.data[item.data.length - 1]
            attributes[key] = item.data.length > 0 ? lastValue[1] : null
        }
        
        var siloKeys = agTypes.telemetry.silo;
        vm.cropData = {
            device: vm.silo,
            algorithm: attributes.algorithm,
            deviceType: attributes.deviceType,
            measurePoints: vm.measurePoints,
            cropPoints: attributes[siloKeys.cropPoints]
        };
        
        vm.siloData = {
            silo: vm.silo,
            sensorLines: [],
            levelIndicators: vm.levelIndicatorDevices,
            cropData: angular.copy(vm.cropData)
        };

        let cropDensity = Math.max(0, attributes[siloKeys.cropDensity])
        let siloVolume = Math.max(0, attributes[siloKeys.siloVolume]);
        vm.maxSiloWeight = siloVolume * cropDensity / 1000;
        
        vm.minCropLevel = attributes[siloKeys.cropLevelMin];
        vm.avgCropLevel = attributes[siloKeys.cropLevelAvg];
        vm.maxCropLevel = attributes[siloKeys.cropLevelMax];
        
        vm.currentCropVolume = attributes[siloKeys.cropVolume]
        let maxCropVolume = attributes[siloKeys.siloVolume]
        vm.cropVolumePercentage = null
        if (maxCropVolume !== null && vm.currentCropVolume !== null) {
            vm.cropVolumePercentage = 100 * vm.currentCropVolume / maxCropVolume;
        }
        vm.cropWeight = attributes[siloKeys.cropWeight];

        if (apply) {
            $scope.$digest();
        }
        vm.dataReady = true;
    }
    vm.dataReady = false;

    function onDataUpdateError(subscription, e) {
        $log.error(e);
    }

    function getStatusMessage(statusId) {
        var result;
        if (statusId === 1) {
            result = "ag.silo.status-blocked";
        } else if (statusId === 2) {
            result = "ag.silo.status-ready-invalid";
        } else if (statusId === 6) {
            result = "ag.silo.status-ready-valid";
        } else if (statusId === 8) {
            result = "ag.silo.status-busy";
        } else if (statusId === 16) {
            result = "ag.silo.status-failure";
        } else if (statusId === 32) {
            result = "ag.silo.status-not-ready";
        } else {
            result = "ag.silo.status-unknown"
        }
        return result
    }


    function loadSilo() {
        vm.silo = null;
        vm.levelIndicator = null;
        vm.siloData = null;
        reset();
        if (vm.siloId) {
            
            // NOTE: this has to be called for the weight-percentage widget to work
            //$log.info('broadcast create gauge')
            $rootScope.$broadcast("createDigitalGauge");

            vm.loading = true;
            siloService.getSilo(vm.siloId).then(
                (silo) => {
                    vm.silo = silo;
                    if (angular.isDefined(vm.silo.maxCropLevelThreshold) && vm.silo.maxCropLevelThreshold !== null) {
                        vm.cropLevelLegendConfig.maxThresholdLabel = $translate.instant('ag.silo.max-level-threshold');
                        vm.maxCropLevelThreshold = vm.silo.maxCropLevelThreshold;
                    }
                    if (angular.isDefined(vm.silo.minCropLevelThreshold) && vm.silo.minCropLevelThreshold !== null) {
                        vm.cropLevelLegendConfig.minThresholdLabel = $translate.instant('ag.silo.min-level-threshold');
                        vm.minCropLevelThreshold = vm.silo.minCropLevelThreshold;
                    }
                    attributeService.getEntityLatestTimeseriesValues(vm.siloId.entityType, vm.siloId.id, [agTypes.telemetry.silo.cropType]).then(
                        (cropResponse) => {
                            vm.silo.cropType = null;
                            var cropType = cropResponse.crop_type[0].value;
                            if (vm.cropNames) {
                                var currentCropName = $filter('filter')(vm.cropNames, {nameId: cropType}, true);
                                if (currentCropName && currentCropName.length) {
                                    vm.silo.cropType = currentCropName[0];
                                    if (vm.cropValues && vm.cropValues[cropType]) {
                                        var resolvedDensity = Number.isFinite(vm.silo.customCropDensity) ? vm.silo.customCropDensity : vm.cropValues[cropType].density;
                                        var resolvedAngle = Number.isFinite(vm.silo.customCropGlidingAngle) ? vm.silo.customCropGlidingAngle : vm.cropValues[cropType].gliding_angle;
                                        vm.silo.cropDensity = resolvedDensity;
                                        vm.silo.glidingAngle = resolvedAngle;
                                    }
                                }
                                vm.cropLabel = vm.silo.cropType ? "(" + $translate.instant(agTypes.cropNames[vm.silo.cropType.value.name]) + ")" : "";
                            }
                            reloadSiloLevelIndicator();
                        },
                        () => {
                            vm.loading = false;
                        }
                    );
                    reloadSiloLevelIndicator();
                },
                () => {
                    vm.loading = false;
                }
            );
        }
    }

    function reloadSiloLevelIndicator() {
        if (vm.siloId) {
            
            siloService.getSiloLevelIndicator(vm.siloId).then(
                (levelIndicator) => {
                    if (vm.silo) {
                        vm.levelIndicator = levelIndicator[0];
                        if (!vm.levelIndicator) {
                            vm.siloData = {
                                silo: vm.silo,
                                sensorLines: []
                            };
                            vm.hideCropLevel = true;
                        }
                        //$rootScope.$broadcast("createDigitalGauge");
                        vm.loading = false;
                    }
                },
                () => {
                    vm.levelIndicator = null;
                }
            );
        }
    }

    function displayValueTooltip($event, value, units, timeStamp, disableColorFunc) {
        var instances = angular.element.tooltipster.instances();
        instances.forEach((instance) => {
            instance.destroy();
        });
        var element = angular.element($event.target);
        element.tooltipster(
            {
                theme: 'tooltipster-shadow',
                delay: 100,
                trigger: 'custom',
                triggerOpen: {
                    click: false,
                    tap: false
                },
                triggerClose: {
                    click: true,
                    tap: true,
                    scroll: true
                },
                trackOrigin: true
            }
        );
        var levelColor = tempColor(value, disableColorFunc);
        var contentElement = angular.element('<div class="ag-temp-tooltip">' +
            '<a class="ag-temp-tooltip-close-button" id="close" style="outline: none;">×</a>' +
            '<div id="tooltip-content" layout="column">' +
            '<div class="ag-temp-ts">'+timeStamp+'</div>'+
            '<div layout="column" layout-align="center center">' +
            '<div class="ag-temp-value" style="color: '+levelColor+';">'+value+units+'</div>'+
            '</div>' +
            '</div>' +
            '</div>');
        $compile(contentElement)($scope);
        var tooltip = element.tooltipster('instance');
        contentElement.find('#close').on('click', () => {
            tooltip.destroy();
        });
        tooltip.content(contentElement);
        tooltip.open();
    }

    function tempColor(val, disableColorFunc) {
        if (!disableColorFunc) {
            if (angular.isDefined(vm.maxCropLevelThreshold) && val >= vm.maxCropLevelThreshold) {
                return agTypes.colors.errorColor;
            }
            if (angular.isDefined(vm.minCropLevelThreshold) && val <= vm.minCropLevelThreshold) {
                return agTypes.colors.errorColor;
            }
            return agTypes.colors.normalColor;
        }
        return agTypes.colors.normalColor;
    }

    function getStatusColor() {
        if (vm.statusId === 2 || vm.statusId === 6) {
            return "#27ae60";
        } else if (vm.statusId === 1 || vm.statusId === 8) {
            return "#ffb72d";
        } else {
            return "#d53d0e";
        }
    }

    function forceMeasurement () {
        agDeviceService.sendGatewayRpcCommand('force_measurement', {}, vm.levelIndicator.id.id, 500, (error) => {
            showRpcError(error);
        }, 10000).then(
            (responseBody) => {
                if (responseBody.status && responseBody.status === "error") {
                    showRpcError(responseBody.error);
                }
            });
    }

    function showRpcError(error) {
        toast.showError(error, $element.parent(), 'bottom left');
    }







    vm.levelIndicatorDevices = []
    $scope.$watch('vm.levelIndicator', () => {
        if (!vm.levelIndicator || !vm.silo) return
        
        // setup level indicator
        let measurePoints = [] 
        try {
            measurePoints = angular.fromJson(vm.levelIndicator.measurePoints)
        } catch (err) {
            $log.error(err)
        }
        vm.levelIndicatorDevices = [{
            id: vm.levelIndicator.id.id, type: vm.levelIndicator.type,
            attributes: {
                measurePoints: measurePoints,
                cropLevels: {}
            }
        }]
        
        if (!vm.cropData) {
            vm.cropData = {
                measurePoints: vm.measurePoints
            };
        }
        vm.siloData = {
            silo: vm.silo,
            sensorLines: [],
            levelIndicators: vm.levelIndicatorDevices,
            cropData: vm.cropData
        }

        var cropLevelSubscriptionsInfo = [{
            type: types.datasourceType.entity,
            entityType: types.entityType.device,
            entityId: vm.levelIndicator.id.id,
            entityName: vm.levelIndicator.name,
            timeseries: [
                { name: "air-level-1", label: "Air level 1" },
            ],
            attributes: [
                { name: agTypes.attributes.levelIndicatorClient.status, label: 'Crop Level Status'}
            ]
        }];
        
        let cropLevelSubscriptionOptions = {
            callbacks: {
                onDataUpdated: (subscription) => {
                    var data = subscription.data;
                    if (!vm.levelIndicator) return
                    let measurePoints = [] 
                    try {
                        measurePoints = angular.fromJson(vm.levelIndicator.measurePoints)
                    } catch (err) {
                        $log.error(err)
                    }
                    
                    let attributes = {
                        measurePoints: measurePoints
                    }
                    for (var item of data) {
                        let key = item.dataKey.name
                        attributes[key] = item.data.length > 0 ? item.data[0][1] : null
                    }
                    if (attributes['status'] != null) {
                        vm.statusId = attributes['status'];
                        vm.statusMessage = getStatusMessage(vm.statusId);
                    }
                    vm.levelIndicatorDevices = [{
                        id: vm.levelIndicator.id.id, type: vm.levelIndicator.type,
                        attributes: attributes
                    }]
                    vm.siloData.levelIndicators = vm.levelIndicatorDevices
                },
                onDataUpdateError: onDataUpdateError,
                dataLoading: (subscription) => {
                    vm.cropLevelLoading = subscription.loadingData;
                }
            },
            useDashboardTimewindow: false
        };
        
        cropLevelSubscriptionOptions.timeWindowConfig = angular.copy(vm.ctx.dashboardTimewindow);
        cropLevelSubscriptionOptions.timeWindowConfig.aggregation.type = types.aggregation.none.value;
        cropLevelSubscriptionOptions.timeWindowConfig.aggregation.limit = 1;
        
        vm.ctx.subscriptionApi.createSubscriptionFromInfo(
            types.widgetType.timeseries.value, cropLevelSubscriptionsInfo, cropLevelSubscriptionOptions, false, true).then(
            (subscription) => {
                vm.levelIndicatorSubscription = subscription;
            }
        );

    })


    $scope.$watch('vm.silo', () => {
        if (!vm.silo || !vm.silo.id) return;
        vm.cropLevelLoading = true;
        var cropLevelSubscriptionsInfo = [{
            type: types.datasourceType.entity,
            entityType: types.entityType.asset,
            entityId: vm.silo.id.id,
            entityName: vm.silo.name,
            timeseries: [
                //{ name: agTypes.telemetry.silo.cropLevelAvg, label: "Avg Level" },
                { name: agTypes.telemetry.silo.cropWeight, label: "Crop Weight" }
            ],
            attributes: []
        }];
        
        cropLevelSubscriptionsInfo[0].timeWindowConfig = angular.copy(vm.ctx.dashboardTimewindow);
        vm.cropLevelFlotSubscriptionsInfo = angular.copy(cropLevelSubscriptionsInfo);
        
        cropLevelSubscriptionsInfo[0].timeseries.push(
            { name: agTypes.telemetry.silo.cropPoints, label: "Crop Points" },
            { name: agTypes.telemetry.silo.cropVolume, label: "Crop Volume" },
            { name: agTypes.telemetry.silo.cropWeight, label: "Crop Weight" },
            { name: agTypes.telemetry.silo.cropType, label: "Crop Type" },
            { name: agTypes.telemetry.silo.siloVolume, label: "Silo Volume" },
            { name: agTypes.telemetry.silo.cropLevelMin, label: "Min Level" },
            { name: agTypes.telemetry.silo.cropLevelMax, label: "Max Level" },
            { name: agTypes.telemetry.silo.cropDensity, label: "Crop Density" }
        )
        
        vm.cropLevelSubscriptionOptions.timeWindowConfig = angular.copy(vm.ctx.dashboardTimewindow);
        vm.cropLevelSubscriptionOptions.timeWindowConfig.aggregation.type = types.aggregation.none.value;
        vm.cropLevelSubscriptionOptions.timeWindowConfig.aggregation.limit = 1;
        vm.ctx.subscriptionApi.createSubscriptionFromInfo(
            types.widgetType.timeseries.value, cropLevelSubscriptionsInfo, vm.cropLevelSubscriptionOptions, false, true).then(
            (subscription) => {
                vm.subscription = subscription;
            }
        );
    });
}